var languageType = require('./languageCommon.js')
var language = localStorage.getItem('language') || 'zh-CN'

if(language=='zh-CN'){
  document.getElementsByTagName('meta')[1].setAttribute('content',panoramaListMeta[language])
  document.getElementsByTagName('meta')[2].setAttribute('content',panoramaListKey[language])
  document.title = panoramaListTitle[language];
}else{
  document.getElementsByTagName('meta')[1].setAttribute('content',panoramaListMeta['USA'])
  document.getElementsByTagName('meta')[2].setAttribute('content',panoramaListKey['USA'])
  document.title = panoramaListTitle['USA'];
}

$('.commonlanguage').html(commonlanguage[language])
$('title').html(panoramaListTitle[language]);
$('.commonHomePage').html(commonHomePage[language]);
$('.commonLvyue').html(commonLvyue[language]);
$('.commonAboutLvyue').html(commonAboutLvyue[language]);
$('.commonlvyueBrand').html(commonlvyueBrand[language]);
$('.commonFlowerConstruction').html(commonFlowerConstruction[language]);
$('.commonFloralLux').html(commonFloralLux[language]);
$('.commonClaim').html(commonClaim[language]);
$('.commonWeiLai').html(commonWeiLai[language]);
$('.commonTanChen').html(commonTanChen[language]);
$('.commonflowerTravel').html(commonflowerTravel[language]);
$('.commonJoinInCooperation').html(commonJoinInCooperation[language]);
$('.commonPanorama').html(commonPanorama[language]);
$('.commonZh').html(commonZh[language]);
$('.commonUsa').html(commonUsa[language]);
$('.commonJp').html(commonJp[language]);
$('.commonKo').html(commonKo[language]);
$('.commonTh').html(commonTh[language]);
$('.commonYh').html(commonYh[language]);
$('.commonReservations a').html(commonReservations[language]);
$('.commonClose').html(commonClose[language]);
$('.commonFreebooking').html(commonFreebooking[language]);
$('.commonDownload').html(commonDownload[language]);
$('.commonWechatSubscription').html(commonWechatSubscription[language]);



/** WEBPACK FOOTER **
 ** ./src/js/quanjingListLanguage.js
 **/